export function Container({ center, children }) {
    const className = center ? `container__center` : 'container';
    return <div className={className}>{children}</div>;
}
